import React from "react";
import "./CaseTabs.css";

import { renderIcon } from "../../utils";



const CaseTabs = ({ id, title, active, setSelected, Icon=false }) => {

  return (
    <li
      key={id}
      className={active ? "button active" : "button"}
      onClick={() => setSelected(id)}
    >
      {/* Show icon if provided */}
      {Icon && <div className='icon'>{renderIcon(title)}</div>}
      {title} {/* Display the title */}
    </li>
  );

};

export default CaseTabs;